if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loadAdditionalData !== 'true') return;

        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.fetchAdditionalData();
              observer.unobserve(entry.target);
            }
          });
        });

        observer.observe(this);
      }

      constructor() {
        super();

        this.placeholder = this.querySelector('.product-card__additional-data--placeholder');
        this.url = this.querySelector('.product-card__link')?.getAttribute('href')?.split('?')[0];
        this.footer = this.querySelector('.product-card__footer');
      }

      fetchAdditionalData() {
        fetch(this.url + `?section_id=product-card-additional-data`)
          .then((response) => response.text())
          .then((html) => {
            const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
            const additionalData = parsedHTML.querySelector('.product-card__additional-data');
            const productIndex = parsedHTML.querySelector('.product-index');

            this.footer && additionalData && this.footer.appendChild(additionalData);
            this.placeholder && this.placeholder.remove();

            if (this.dataset.showIndex === 'true' && this.nextElementSibling) {
              this.nextElementSibling.querySelector('.product-index__title')?.remove();
              this.nextElementSibling.querySelector('.product-index__variants')?.remove();

              this.nextElementSibling.appendChild(productIndex?.querySelector('.product-index__title'));
              this.nextElementSibling.appendChild(productIndex?.querySelector('.product-index__variants'));
            }

            setTimeout(() => {
              this.setAttribute('data-additional-data-loaded', 'true');
            }, 15);
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
  );
}
